import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Score from '@/components/Score'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login
        },
        {
            path: '/score',
            name: 'Score',
            component: Score
        }
    ]
})
